module.exports = __webpack_public_path__ + "img/es.173eaa04.png";